import { Component, OnInit } from '@angular/core';
import { SharedBookingAccessHelperService } from '../../services/shared-booking-access-helper.service';

@Component({
	selector: 'vl-booking-access-info',
	templateUrl: './booking-access-info.component.html',
	styleUrls: ['./booking-access-info.component.scss'],
})
export class BookingAccessInfoComponent implements OnInit {
	constructor(public sharedAccessHelpService: SharedBookingAccessHelperService) {
	}

	ngOnInit() {
	}

}
